export const PROFILE = "PROFILE";
export const PROFILE_INTRODUCTION = {
  id : "introduction",
  title : "INTRODUCTION"
}
export const PROFILE_EDUCATION = {
  id : "section-education",
  title : "EDUCATION"
};

export const PROFESSIONAL = "PROFESSIONAL";
export const PRO_CAREER = {
  id : "section-pro-career-resume",
  title : "CAREER RESUME"
};
export const PRO_EMPLOYMENT = {
  id : "section-pro-employment-exp",
  title : "EMPLOYMENT EXPERIENCE",
  menuTitle : "EMPLOYMENT EXP."
};
export const PRO_INDEPENDENT = {
  id : "section-pro-ind-exp",
  title : "INDEPENDENT EXPERIENCE",
  menuTitle : "INDEPENDENT EXP."
};

export const NONPROFESSIONAL = "NON-PROFESSIONAL";
export const NONPRO_WEB = {
  id : "section-nonpro-web",
  title: "WEB DESIGN"
}
export const NONPRO_COLLABORATIONS = {
  id : "section-nonpro-collaborations",
  title: "COLLABORATIONS"
}

export const SKILLS = "SKILLS";
export const SKILLS_TRANINGS = {
  id :"section-skills-trainings" ,
  title: "TRANINGS"
}
export const SKILLS_LANGUAGE = {
  id : "section-skills-language",
  title: "LANGUAGE"
}
export const SKILLS_SOFTWARE = {
  id : "section-skills-software" ,
  title: "SOFTWARE"
}


export const CV_PARTS = {
  [PROFILE]: {
    icon: "Icon-CV_Profile",
    sections: [PROFILE_INTRODUCTION, PROFILE_EDUCATION],
  },
  [PROFESSIONAL]: {
    icon: "Icon-CV_Set 1_Pro",
    sections: [PRO_CAREER, PRO_EMPLOYMENT, PRO_INDEPENDENT],
  },
  [NONPROFESSIONAL]: {
    icon: "Icon-CV_Set 1_Non-pro",
    sections: [NONPRO_WEB, NONPRO_COLLABORATIONS],
  },
  [SKILLS]: {
    icon: "Icon-CV_Set 1_Skills_Bars Vertical",
    sections: [SKILLS_LANGUAGE, SKILLS_TRANINGS, SKILLS_SOFTWARE],
  },
};

// Icon-CV_Profile
// Icon-CV_Set 1_Pro
// Icon-CV_Set 1_Non-pro
// Icon-CV_Set 1_Skills_Bars Vertical
// Icon-CV_Set 1_Skills_Bars-Horizontal
// Icon-CV_Set 1_Skills_List with bullets
// Icon-CV_Set 1_Skills_Check boxes

// Icon-CV_Set 2_Pro
// Icon-CV_Set 2_Non-Pro
// Icon-CV_Set 2_Skills_List with bullets
// Icon-CV_Set 2_Skills_List with check
// Icon-CV_Set 2_Skills_Check boxes
